module.exports = __webpack_public_path__ + "img/level1_mining_tool_mask.9eed97e8.png";